import { render, staticRenderFns } from "./ActOfPurchaseSigned.vue?vue&type=template&id=ee85a75e"
import script from "./ActOfPurchaseSigned.vue?vue&type=script&lang=js"
export * from "./ActOfPurchaseSigned.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports